import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  CompetencyContentUpdate,
  RubricFieldTypeCompetency,
} from 'src/app/private/shared/types/responses/proforms.responses';
import { ModalComponent } from '../../../modals/modal/modal.component';

@Component({
  selector: 'app-edit-competency-modal',
  standalone: false,
  templateUrl: './edit-competency-modal.component.html',
  styleUrl: './edit-competency-modal.component.scss',
})
export class EditCompetencyModalComponent implements OnInit, OnChanges {
  @ViewChild('modal')
  modal: ModalComponent;

  @Input() levelNames: string[];

  @Input() competency: RubricFieldTypeCompetency;

  @Input() canDeleteCompetency: boolean;

  @Input() competencyIndex: number;

  @Output() readonly competencyUpdated =
    new EventEmitter<CompetencyContentUpdate>();

  @Output() readonly competencyDeleted =
    new EventEmitter<RubricFieldTypeCompetency>();

  competencyForm: FormGroup;

  isUpdating = true;

  formSubmitted = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createFromControls();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['competency'] &&
      changes['competency'].currentValue !==
        changes['competency'].previousValue &&
      changes['competency'].firstChange === false
    ) {
      this.isUpdating = true;
      this.resetForm();
      this.createFromControls();
    }
  }

  get f() {
    return this.competencyForm.controls;
  }

  createFromControls() {
    if (this.competency) {
      this.competencyForm = this.formBuilder.group({});

      for (let i = 1; i <= this.competency.gis.length; i += 1) {
        this.competencyForm.addControl(
          `level${i}`,
          new FormControl(this.competency.gis[i - 1])
        );
      }
      this.competencyForm.addControl(
        'title',
        new FormControl(this.competency.title)
      );
      this.isUpdating = false;
    }
  }

  removeAllFormGroupControls() {
    Object.keys(this.competencyForm.controls).forEach((key) => {
      this.competencyForm.removeControl(key);
    });
  }

  resetForm() {
    this.removeAllFormGroupControls();
    this.formSubmitted = false;
    this.isUpdating = false;
  }

  handleDelete() {
    this.competencyDeleted.emit(this.competency);
    this.closeModal();
  }

  closeModal() {
    this.resetForm();
    this.createFromControls();
    this.modal.close();
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.competencyForm.invalid) {
      return;
    }
    if (this.competencyForm.pristine) {
      this.closeModal();
      return;
    }
    this.isUpdating = true;
    const updatedLevels: string[] = [];
    for (let i = 1; i <= this.competency.gis.length; i += 1) {
      updatedLevels.push(this.f[`level${i}`].value);
    }
    this.competencyUpdated.emit({
      index: this.competencyIndex,
      title: this.f['title'].value,
      gis: updatedLevels,
    });
    setTimeout(() => {
      this.closeModal();
    }, 400);
  }
}
